
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as apipy9rWI89OZMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/api.vue?macro=true";
import { default as _91slug_93UheSwfeB6GMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/blog/[slug].vue?macro=true";
import { default as indexgz8ohYXQlAMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/blog/index.vue?macro=true";
import { default as _91slug_93ENqd8O87CmMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/brand-colors/[slug].vue?macro=true";
import { default as indexlH8CH5PPPuMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/brand-colors/index.vue?macro=true";
import { default as browser_45extension69uLFk8dipMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/browser-extension.vue?macro=true";
import { default as confirm_45emailO9RsL3To3nMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/confirm-email.vue?macro=true";
import { default as confirmO9VXN14LzdMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/confirm.vue?macro=true";
import { default as dashboardaIJeuLoiNkMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/dashboard.vue?macro=true";
import { default as indexSe8lJbV57XMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/index.vue?macro=true";
import { default as loginT9x9ufVgYnMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/login.vue?macro=true";
import { default as onboarding_45completeoJZh6IoFc1Meta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/onboarding-complete.vue?macro=true";
import { default as onboarding_45formVRilZGM8s5Meta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/onboarding-form.vue?macro=true";
import { default as playgroundbrRYqkzHwOMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/playground.vue?macro=true";
import { default as pricingyzVZNiDwQwMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/pricing.vue?macro=true";
import { default as registerODw1sJH8n5Meta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/register.vue?macro=true";
import { default as reset_45passwordoljpFlzUxeMeta } from "/Users/nestoras/Documents/GitHub/colorize-frontend/pages/reset-password.vue?macro=true";
export default [
  {
    name: "api",
    path: "/api",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/api.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/blog/index.vue")
  },
  {
    name: "brand-colors-slug",
    path: "/brand-colors/:slug()",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/brand-colors/[slug].vue")
  },
  {
    name: "brand-colors",
    path: "/brand-colors",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/brand-colors/index.vue")
  },
  {
    name: "browser-extension",
    path: "/browser-extension",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/browser-extension.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/confirm-email.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/confirm.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardaIJeuLoiNkMeta || {},
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/dashboard.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/login.vue")
  },
  {
    name: "onboarding-complete",
    path: "/onboarding-complete",
    meta: onboarding_45completeoJZh6IoFc1Meta || {},
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/onboarding-complete.vue")
  },
  {
    name: "onboarding-form",
    path: "/onboarding-form",
    meta: onboarding_45formVRilZGM8s5Meta || {},
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/onboarding-form.vue")
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundbrRYqkzHwOMeta || {},
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/playground.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/pricing.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/register.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/pages/reset-password.vue")
  }
]